import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="border-b border-white/10 bg-ink-900" data-id="element-257" data-mp="3mgafkkhj9ipu">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-6xl" data-id="element-258" data-mp="3mepkmtrb3xrg">
        <h2 className="text-center font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-259" data-mp="3r93m9dwkb14k">
          ⭐ Cosa dicono <span className="text-accent" data-id="element-260" data-mp="42t53hxf73ro">altri tecnici</span>
        </h2>

        <ul className="mt-9 grid gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-261" data-mp="44w2wo4te16y">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800 p-5 sm:p-6" data-id="element-262" data-mp="902wv48a7rio">
              <QuoteIcon className="h-6 w-6 text-accent/50" aria-hidden="true" data-id="element-263" data-mp="2autwqggl36c5" />
              <blockquote className="mt-3 text-[14.5px] leading-relaxed text-white/80 sm:text-[15px]" data-id="element-264" data-mp="2ftev0ac9zfxy">
                “{testimonial.quote}”
              </blockquote>

              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-265" data-mp="1nu2oqmicb3vy">
                <img src={testimonial.photo} alt={`${testimonial.name}, tecnico da ${testimonial.country}`} className="h-12 w-12 shrink-0 rounded-full border border-accent/30 object-cover" width={96} height={96} data-id="element-266" data-mp="1nrq1btttc1bi" />
                <div className="min-w-0" data-id="element-267" data-mp="26kalmmvg4y3p">
                  <p className="truncate text-sm font-semibold text-white" data-id="element-268" data-mp="26lls4uga0jyi">{testimonial.name}</p>
                  <p className="truncate text-[12px] text-white/45" data-id="element-269" data-mp="22he0opifopwl">{testimonial.country}</p>
                  <div className="mt-1 flex gap-0.5" aria-hidden="true" data-id="element-270" data-mp="1xikn6x35cywf">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3 w-3 fill-accent text-accent" data-id="element-271" data-mp="r4v21b5zioqg" />)}
                  </div>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md lg:max-w-lg" data-id="element-272" data-mp="njjhgjnc7a49">
          <CtaButton label="Voglio risultati come questi" data-id="element-273" data-mp="sjo1gjngemz8" />
        </div>
      </div>
    </section>;
}